import { createStore } from "redux";
import { SummaryType } from "./seomapitype";
import moment from "moment";
import { DefaultRootState } from "react-redux";
import { FilterTypes, Plan, PlanDetail } from "./types/plan";
import {
  ControlResultByManufacturer,
  ControlResultByDevice,
  DownloadRequestData,
} from "./types/control-result";
import { AuthUser } from "@aws-amplify/auth";

export interface ApplicationState extends DefaultRootState {
  planList: Plan[];
  planUnitList: any[];
  planDetail: PlanDetail;
  spinner: boolean;
  sidebarShow: boolean | "" | "responsive" | undefined;
  sitesData: any[];
  mainSeriesData: any[];
  measurementSeriesData: any[];
  siteMeasurementData: any[];
  siteId: string;
  siteList: any[];
  currentPage: number;
  sitesCondition: any;
  sitesPaginationData: any;
  siteNameList: any[];
  siteNameFlag: string;
  failuresCondition: any;
  failuresPaginationData: any;
  chartUnitSelection: SummaryType;
  modalUnitSelection: SummaryType;
  chartTargetTimestamp: number;
  modalChartTargetTimestampFrom: number;
  modalChartTargetTimestampTo: number;

  downloadCsvStatus: {
    executionArn: string;
    status: string | undefined;
    responseBody: string;
  };

  chartLegendCollapsedChanged: boolean;
  chartUpdated: boolean;
  searchMVColumnFilter: {
    device_name: string;
    device_type: string;
    // 'signal_name': '',
    disp_signal_name: string;
  };
  searchSitesColumnFilter: {
    name: string;
    owner: string;
    device_name: string;
    area_name: string;
    group_name: string;
  };
  searchFailuresColumnFilter: {
    site_name: string;
    owner: string;
    device_name: string;
    failure_status: string;
  };
  cognitoUser: AuthUser | null;
  loading: boolean;
  modal: boolean;
  announceShowList: any[];
  announceData: any[];

  siteChartFullScreen: boolean;
  siteDetailChartFullScreen: boolean;
  controlResultByManufacturer: ControlResultByManufacturer | null;
  controlResultByDevice: ControlResultByDevice | null;
  uploadFile: File[];
  filterForm: FilterTypes;
  downloadRequestData: DownloadRequestData[]
}

const initialState: ApplicationState = {
  spinner: false,
  sidebarShow: "responsive",
  sitesData: [],
  mainSeriesData: [],
  measurementSeriesData: [],
  siteMeasurementData: [],

  siteId: "",
  siteList: [],
  currentPage: 1,
  sitesCondition: {},
  sitesPaginationData: {},
  siteNameList: [],
  siteNameFlag: "",

  // failuresData : [],
  failuresCondition: {},
  failuresPaginationData: {},

  chartUnitSelection: SummaryType.DAY,

  // ダウンロード画面上の時間粒度の状態を管理
  modalUnitSelection: SummaryType.DAY_30MIN,
  chartTargetTimestamp: moment().startOf("day").unix(),
  modalChartTargetTimestampFrom: moment().startOf("day").unix(),
  modalChartTargetTimestampTo: moment().startOf("day").unix(),

  //ダウンロード画面のStepFunctions状態を管理
  downloadCsvStatus: {
    executionArn: "",
    status: undefined,
    responseBody: "",
  },

  chartLegendCollapsedChanged: false,
  chartUpdated: false,
  searchMVColumnFilter: {
    device_name: "",
    device_type: "",
    // 'signal_name': '',
    disp_signal_name: "",
  },
  searchSitesColumnFilter: {
    name: "",
    owner: "",
    device_name: "",
    area_name: "",
    group_name: "",
  },
  searchFailuresColumnFilter: {
    site_name: "",
    owner: "",
    device_name: "",
    failure_status: "",
  },
  cognitoUser: null,
  loading: false,
  modal: false,
  announceShowList: [],
  announceData: [],

  siteChartFullScreen: true,
  siteDetailChartFullScreen: false,
  planList: [],
  planUnitList: [],
  planDetail: {
    dr_date: "",
    vpp_flex_retail_unit_id: "",
    vpp_flex_retail_unit_name: "",
    retailer_name: "",
    electricity_area_name: "",
    min30_unit_schedule: "",
    economic_flg: false,
    economic_profit: 0,
    do_dr_flg: false,
    forcast_demand_power_array: [],
    forcast_generation_power_array: [],
    jepx_price_array: [],
    economic_evaluations_array: [],
    battery_simulation_array: [],
    battery_simulation_dr_array: [],
    chg_dischg_ratio: []
  },
  controlResultByManufacturer: null,
  controlResultByDevice: null,
  uploadFile: [],
  filterForm: {
    retailer_name: "",
    electricity_area_name: "",
    vpp_flex_retail_unit_name: "",
  },
  downloadRequestData: []
};

const changeState = (
  state = initialState,
  { type, ...rest }: Record<string, any>
) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    case "clear":
      return initialState;
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
